import BaseApiService from "./base-services/baseApi.service";

class MyAccountApiService extends BaseApiService {
    constructor() {
        super();
    }

    createPatientAddress = async (data) => {
        const url = `/access/create-address`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getPatientList = async () => {
        const url = `/access/all-patients`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    getSelectedAddress = async (addressId) => {
        const url = `/access/address/set-default-address`;
        const res = await this.axiosInstance.post(url, addressId);
        return res.data;
    };

    getPatientAddressList = async () => {
        const url = `/access/all-address`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    deletePatientAddress = async (data) => {
        const url = `/access/delete-address`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    updatePatientDetails = async (data) => {
        const url = `/access/update-patient`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    updatePatientAddress = async (data) => {
        const url = `/access/update-address`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getAddressDetailsById = async (addressId) => {
        const url = `/access/address/address-detail?uid=${addressId}`;
        const res = await this.axiosInstance.post(url);
        return await res.data;
    };

    getPatientDetailsById = async (pId) => {
        const url = `/access/patient/patient-detail?uid=${pId}`;
        const res = await this.axiosInstance.post(url);
        return await res.data;
    };

    transferPatient = async (data) => {
        const url = `/access/transfer-patient`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getViewTickets = async () => {
        const url = `/ticket/get-all-tickets`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    createTicket = async (data) => {
        const url = `/ticket/create-ticket`;
        const res = await this.axiosInstance.post(url, data);
        return res;
    };

    getTicketDetails = async (ticketId) => {
        const url = `/ticket/get-ticket?ticketId=${ticketId}`;
        const res = await this.axiosInstance.post(url);
        return res;
    };

    replyTicket = async (data) => {
        const url = `/ticket/reply-ticket`;
        const res = await this.axiosInstance.post(url, data);
        return res;
    };

    getCurrentOrder = async (payload) => {
        const url = `/access/order/current?interval=${payload.interval}`;
        const res = await this.axiosInstance.post(url);
        return res?.data;
    };

    getArchivalReports = async () => {
        const url = `/access/order/archive`;
        const res = await this.axiosInstance.post(url);
        return await res.data;
    };

    getArchivalPatientReports = async (key) => {
        const url = `/access/report/archive?key=${key}`;
        const res = await this.axiosInstance.post(url);
        return await res.data;
    };

    gethealthGraphList = async (patientId) => {
        const url = `/access/account/health-graphs/params-list/by-patient-id?uid=${patientId}`;
        const res = await this.axiosInstance.post(url);
        return res?.data;
    };

    getObservationList = async (payload) => {
        const url = `/access/account/health-graphs/graph`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    validateEmail = async (emailId) => {
        const url = `/access/validate-email?emailId=${emailId}`;
        const res = await this.axiosInstance.post(url);
        return await res.data;
    };

    getEmailAddress = async () => {
        const url = `/access/fetch-patient-email`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };
}
const myAccountApiService = new MyAccountApiService();
export { myAccountApiService };
